import moment from 'moment';
import StepShell from '../StepShell';
import { colors } from '../styles';
import { BaseStepProps } from '../steps/BaseStepProps';

const formatDate = (raw?: string): string => {
  if (!raw) return '';
  const parsed = moment(raw);
  return parsed.isValid() ? parsed.format('MM/DD/YYYY') : '';
};

const CompletedStepView = ({
  step,
  stepIndex,
  totalSteps,
  completedSteps,
  onBack,
  onPrevious,
  onNext,
}: BaseStepProps) => {
  const dateLabel = formatDate(step.signatureDate);
  const source = step.wasUploaded ? 'submitted as an uploaded document by your administrator' : 'completed';

  return (
    <StepShell
      stepNumber={stepIndex + 1}
      totalSteps={totalSteps}
      completedSteps={completedSteps}
      title={step.title}
      onBack={onBack}
      onPrevious={onPrevious}
      onNext={onNext}
      nextLabel="Continue"
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 14,
          padding: 18,
          background: '#F0FDF4',
          border: `1px solid #86EFAC`,
          borderRadius: 12,
          marginBottom: 12,
        }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: '50%',
            background: colors.success,
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 20,
            flexShrink: 0,
          }}
        >
          <i className="fas fa-check" />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: '#065F46' }}>Already submitted</div>
          <div style={{ fontSize: 13, color: '#065F46', marginTop: 2 }}>
            This document was {source}
            {dateLabel ? ` on ${dateLabel}` : ''}.
          </div>
        </div>
      </div>

      <p style={{ color: colors.muted, fontSize: 13, margin: 0 }}>
        For your security, the contents are not displayed here. You can review the filled and signed document in your
        employee profile.
      </p>
    </StepShell>
  );
};

export default CompletedStepView;
